import CircularProgress from "@mui/material/CircularProgress";

interface AppLoaderProps {
  size?: number;
  thickness?: number;
  color?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({
  size = 48,
  thickness = 4,
  color = "#38B2AC",
}) => {
  return <CircularProgress size={size} thickness={thickness} sx={{ color }} />;
};

export default AppLoader;
